import { render, staticRenderFns } from "./CodeView.vue?vue&type=template&id=7c1d08c0&scoped=true&"
import script from "./CodeView.vue?vue&type=script&lang=js&"
export * from "./CodeView.vue?vue&type=script&lang=js&"
import style0 from "./CodeView.vue?vue&type=style&index=0&id=7c1d08c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1d08c0",
  null
  
)

export default component.exports